"use client";

import { getTurnkeyRecoverySessionProfileId } from "@/config/turnkey";
import { useCanCreateEmbeddedWallet } from "@/lib/hooks/flags/use-can-create-embedded-wallet";
import { useRecoveryStatus } from "@/subsystems/embedded-wallets/use-recovery-status";

// Re-usable logic to check if turnkey root user needs to enroll a passkey.
export function useNeedsSignerEnroll(): boolean {
  const canUse = useCanCreateEmbeddedWallet();
  const status = useRecoveryStatus({ enabled: canUse });
  const recoveryConfigured = Boolean(getTurnkeyRecoverySessionProfileId());
  return (
    canUse &&
    recoveryConfigured &&
    status.data?.hasWallet === true &&
    status.data.isSigner === true &&
    status.data.hasPasskey === false
  );
}
